import { createFileRoute } from "@tanstack/react-router";

// biome-ignore lint: generated TanStack route typing false positive
// @ts-ignore TanStack file-route typing does not resolve this generated df-admin path correctly.
export const Route = createFileRoute("/df-admin/quality-guard/configuration")({
  component: () => null,
});
